import { supabase } from './supabaseClient';

/**
 * Hae nykyinen käyttäjä
 * @returns {Promise<{user: User | null, error: Error | null}>}
 */
export const getCurrentUser = async () => {
  if (!supabase) {
    return { user: null, error: new Error('Supabase client not initialized') };
  }

  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    return { user, error };
  } catch (err) {
    return { user: null, error: err };
  }
};

/**
 * Hae käyttäjän profiili
 * @param {string} userId
 * @returns {Promise<{data: any, error: Error | null}>}
 */
export const getProfile = async (userId) => {
  if (!supabase) {
    return { data: null, error: new Error('Supabase client not initialized') };
  }

  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error && error.code !== 'PGRST116') {
      // PGRST116 = not found, ok
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    return { data: null, error: err };
  }
};

/**
 * Hae käyttäjän syntymätiedot
 * @param {string} userId
 * @returns {Promise<{data: any, error: Error | null}>}
 */
export const getBirthData = async (userId) => {
  if (!supabase) {
    return { data: null, error: new Error('Supabase client not initialized') };
  }

  try {
    const { data, error } = await supabase
      .from('birth_data')
      .select('*')
      .eq('user_id', userId)
      .single();

    if (error && error.code !== 'PGRST116') {
      // PGRST116 = not found, ok
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    return { data: null, error: err };
  }
};
